module.exports = __webpack_public_path__ + "media/Video 105.4ada94e6.mp4";